export const counter = (maxLength, length) => {
  if (maxLength - length < 0) {
    return 0;
  }
  return maxLength - length;
};
